import React from 'react';
import { BookOpenIcon, UtensilsIcon, CheckSquareIcon, ShieldAlertIcon, SunriseIcon, RefreshCwIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: <BookOpenIcon className="w-6 h-6 text-brand-dark" data-id="element-261" />,
    title: 'Ebook Protocolo Desincha40+',
    text: 'Um guia direto, simples e fácil de seguir, explicando o que fazer em cada fase.'
  }, {
    icon: <UtensilsIcon className="w-6 h-6 text-brand-dark" data-id="element-262" />,
    title: 'Cardápio de 21 Dias',
    text: 'Refeições práticas para café da manhã, almoço, jantar e lanches, com foco em leveza e saciedade.'
  }, {
    icon: <CheckSquareIcon className="w-6 h-6 text-brand-dark" data-id="element-263" />,
    title: 'Checklist Diário',
    text: 'Para você saber exatamente o que fazer ao acordar, durante o dia e antes de dormir.'
  }, {
    icon: <ShieldAlertIcon className="w-6 h-6 text-brand-dark" data-id="element-264" />,
    title: 'Protocolo SOS 24 Horas',
    text: 'Um plano de retomada para usar depois de festas, finais de semana, viagens ou exageros.'
  }, {
    icon: <SunriseIcon className="w-6 h-6 text-brand-dark" data-id="element-265" />,
    title: 'Ritual Matinal de 2 Minutos',
    text: 'Uma sequência simples para começar o dia hidratando, ativando a digestão e organizando sua rotina.'
  }, {
    icon: <RefreshCwIcon className="w-6 h-6 text-brand-dark" data-id="element-266" />,
    title: 'Lista de Substituições Inteligentes',
    text: 'Trocas fáceis para reduzir o inchaço sem sentir que está de dieta.'
  }];
  return <section className="py-16 md:py-24 bg-brand-cream" data-id="element-267">
      <div className="max-w-6xl mx-auto px-5 md:px-8" data-id="element-268">
        <div className="text-center mb-16" data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark" data-id="element-270">
            O Que Você Recebe
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-271">
          <div className="lg:w-1/3 flex justify-center" data-id="element-272">
            <img src="https://cdn.magicpatterns.com/uploads/pSwpDw56UKbHkib8Dj6KR7/magnific_premium-digital-ebook-moc_43x865h9Aa.png" alt="Materiais do Protocolo Desincha40+" className="w-full max-w-sm drop-shadow-2xl" data-id="element-273" />
          </div>

          <div className="lg:w-2/3 grid sm:grid-cols-2 gap-6" data-id="element-274">
            {items.map((item, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-brand-sage/20 flex flex-col h-full" data-id="element-275">
                <div className="bg-brand-beige w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-276">
                  {item.icon}
                </div>
                <h4 className="text-lg font-bold text-brand-dark mb-2" data-id="element-277">
                  {item.title}
                </h4>
                <p className="text-brand-text/80 text-sm leading-relaxed flex-grow" data-id="element-278">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}